import { Typography } from 'antd'
import styled from 'styled-components'

const StyledUnknownWordsTranslationText = styled(Typography.Text)`
  color: #1b9201;
`

export default StyledUnknownWordsTranslationText
